const React = require('react');
const BtnWithIcon = require('../BtnWithIcon');
const AddIcon = require('@material-ui/icons/Add').default;

module.exports = (props) => {
  return (
    <BtnWithIcon
      {...props}
      className={
        `w45@m2
        w15>.MuiSvgIcon-root 
        (dN)@m2>.text
        (sr50%|x50%Y-50%)@m2>.icon
        w20@m2>.MuiSvgIcon-root`
      }
      icon={<AddIcon />}
    />
  )
}
